import React, {Component} from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import Webcam from "react-webcam";
import RecordAndShow from "./RecordAndShow";
import Timer from "./Timer";
import AppRouter from "./RouteIt";


const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: "user"
};


class App extends Component {


    constructor(props) {
        super(props)
        this.state = {
            questionsShow: true,
            interviewComplete: false
        }

    }


    render() {




        const suggestions = ["Eye Contact", "Fillers", "Voice Volume", "Posture", "Clothing"];
        const suggestionsv2 = [{
            text: "Eye Contact",
            subtitle: "Try and look directly at the camera. If you look away this is regarded as non-genuineness."
        },
            {text: "Fillers", subtitle: "Take some time and think through your answers before talking. Pausing while speaking can cause confusion."},
            {text: "Voice Volume", subtitle: "Audability is very important, speak in a clear loud (ish) tone so it is easy to understand."},
            {text: "Posture", subtitle: "Posture is important, have your hands relaxed. Don't fold your hands as research shows that does not leave a good impression"},
            {text: "Clothing", subtitle: "Smart casual and neat clothes are good."}
        ];

        const questionBox = (
            <div>
                <div className={"card-panel"}>

                    <h1>?</h1>

                    <p>Tell us about yourself and your weaknesses in a professional environment are?</p>

                    <Timer time={10000} onFinished={() => {
                        this.setState({questionsShow: false})
                    }}/>


                </div>


                <br/><br/>
                <h5 className={"grey-text"}>From your previous attemps, try focus on improving on </h5>
                <br/>
                {
                    suggestions.map(item => {
                        return (
                            <div className="chip">
                                {item}
                            </div>
                        )
                    })
                }

            </div>
        )

        const report = (
            <div>
                <h2> Now let's analyze your attempt </h2>




                {
                    suggestionsv2.map(item => {
                        const percentage = Math.random() * 100;
                        let color = "";
                        let comment = "";

                        if (percentage < 30) {
                            color = "red"
                            comment = "This is an area for improvement."
                        } else if (percentage < 60) {
                            color = "orange"
                            comment = "You did alright, we can work on it."
                        } else {
                            color = "green"
                            comment = "Great job, you are good at this."
                        }

                        return (
                            <div>

                                <div className="chip">
                                    {item.text + " " + percentage.toFixed(0) + "%"}
                                </div>



                                <p className={"grey-text"}>{comment + " " +item.subtitle}</p>


                                <div className={"progress lighten-4 " + color}>
                                    <div className={"determinate " + color} style={{width: percentage + "%"}}></div>
                                </div>
                                <br/><br/>
                            </div>
                        )
                    })
                }

                <button className={"btn blue"} style={{borderRadius: "3.5em"}}>
                    Human Feedback
                </button>
            </div>
        );


        return (


            <div className={"row"}>


                <div className={"col s12 m10 offset-m1 l8 offset-l2"}>

                    {

                        !this.state.interviewComplete ? (

                            this.state.questionsShow ? questionBox : <RecordAndShow onFinishedVideo={() => {

                                this.setState({interviewComplete: true})
                            }}/>
                        ) : report

                    }

                </div>


            </div>


        )

    }
}

export default App;
